import { SmartPricingPreferences } from '../../components/provider/smartPricing/types';
import { loadProvider } from '../Api';

/**
 * Calculates the service cost upcharge with smart pricing
 * @param serviceCost The service cost
 * @param smartPrice The smartPrice to apply
 * @returns the service cost
 */
export function calculateSmartPriceUpcharge(
  serviceCost: number,
  smartPriceData: SmartPricingPreferences,
): number {
  let upcharge = 0;
  if (smartPriceData) {
    upcharge = Math.ceil(serviceCost * Number(smartPriceData.service_upcharge)) / 100;

    if (smartPriceData.service_upcharge_cap) {
      upcharge = Math.min(upcharge, smartPriceData.service_upcharge_cap);
    }
  }
  return upcharge;
}

/**
 * Check if the current user booking with the provider would incur a smart price.
 *
 * @param providerId: the provider primary key
 * @returns {Promise<boolean>}
 */
export async function getIsSmartPriceEligible(providerId): Promise<boolean> {
  const {
    smart_pricing_enabled: smartPricingEnabled,
    can_process_payments: canProcessPayments,
  } = await loadProvider(providerId);

  return smartPricingEnabled && canProcessPayments;
}
